import React from "react";
import {
  ExlyIconButton,
  ExlyMenu,
  ExlyMenuItem,
  ExlyMoreHorizIcon,
} from "common/Components/ExlyActionMenu/ExlyActionMenuWrappers";
import { useActionMenu } from "../hooks/useActionMenu";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../../constants/ZoomAttendance.constants";

export const ActionMenuCell = ({
  record,
  onMapToBooking,
  onCreateNewBooking,
}) => {
  const {
    anchorEl,
    isOpen,
    handleClick,
    handleClose,
    handleMap,
    handleCreate,
  } = useActionMenu({
    record,
    onMapToBooking,
    onCreateNewBooking,
  });

  return (
    <div>
      <ExlyIconButton size="small" onClick={handleClick}>
        <ExlyMoreHorizIcon fontSize="small" />
      </ExlyIconButton>
      <ExlyMenu
        anchorEl={anchorEl}
        keepMounted
        open={isOpen}
        onClose={handleClose}
      >
        <ExlyMenuItem onClick={handleMap}>
          {ZOOM_ATTENDANCE_CONSTANTS.LABELS.MAP_TO_BOOKING}
        </ExlyMenuItem>
        <ExlyMenuItem onClick={handleCreate}>
          {ZOOM_ATTENDANCE_CONSTANTS.LABELS.CREATE_NEW_BOOKING}
        </ExlyMenuItem>
      </ExlyMenu>
    </div>
  );
};
